import React from "react";
//
import { Typography, Card, CardActionArea, CardContent, CardMedia } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  card: {
    maxWidth: 500,
    float: "right",
  },
  media: {
    height: 340, // necessory for card image
  },
  p: {
    padding: 3,
  },
});

export const AboutStore = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="h3">About Stroke</Typography>
      <Typography variant="body1">
        Approximately <strong>800,000</strong> people every year in the United States <strong>have stroke</strong> and{" "}
        <strong>140,000</strong> Americans each year <strong>die from stroke</strong>.
      </Typography>
      <Typography variant="body1">
        A stroke happens when a brain blood vessel blocked ( ischemic stroke) or burst ( hemorrhage stroke).
      </Typography>
      <Typography variant="body1">This causes brain tissue lack of oxygen and nutrients.</Typography>
      <Typography variant="body1">
        Brain controls mood, behavior, memory, <strong>moor and sensory functional, coordination,</strong> breathing and
        heart rate.
      </Typography>
      
      
    </div>
  );
};
